import { JellyTriangle } from 'ldrs/react';
import 'ldrs/react/JellyTriangle.css';
import './v1.css';

export const DefaultLoader = () => {

  return (
    <>
    <div className='loader-container'>
      <JellyTriangle size="100" speed="2.50" color="#002759" />
    </div>
  </>
  );
};
